import axios from './axios';

const getGeneralFolders = async (token, entityType ) => {
  const response = await axios.get(`generalFolders/`, { headers: { Authorization: "Bearer " + token } });
  return response.data ? response.data : [];

}
 

export { getGeneralFolders };